module.exports = __webpack_public_path__ + "img/PRCA1_Endothelial.8dacb464.png";